import {connect} from '@modifi/redux'

import {FormInputContextProvider} from '@modifi/plugin-onboarding'
import {OnboardingActivationStatus} from '@modifi/enums'

import ONBOARDING_VALIDATION_RULES from '../../constants/validation-rules'
import {selectCompanyIsLocked, selectCompanyActivationStatus} from '../../data/company'
import {
  selectVisibleInputFieldNames,
  selectReadOnlyInputFieldNames,
} from '../../modules/input-fields'

const mapStateToProps = (
  state: Record<string, any>
): {
  visibleInputNames: string[]
  readonlyInputNames: string[]
  globalReadonly: boolean
  validationRulesMap: Record<string, any>
} => ({
  visibleInputNames: selectVisibleInputFieldNames(state) as string[],
  readonlyInputNames: selectReadOnlyInputFieldNames(state),
  globalReadonly:
    selectCompanyIsLocked(state) &&
    selectCompanyActivationStatus(state) !== OnboardingActivationStatus.NOT_APPLICABLE,
  validationRulesMap: ONBOARDING_VALIDATION_RULES,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(FormInputContextProvider)
